export class AddToCartProto {
  userId: string;
  productIds: string[] = [];
}
